import { render, staticRenderFns } from "./unfinished-test.vue?vue&type=template&id=f53c4a0a&scoped=true"
import script from "./unfinished-test.vue?vue&type=script&lang=js"
export * from "./unfinished-test.vue?vue&type=script&lang=js"
import style0 from "./unfinished-test.vue?vue&type=style&index=0&id=f53c4a0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53c4a0a",
  null
  
)

export default component.exports